module.exports = __webpack_public_path__ + "6763c8ca80f91fe19077e6ec978d828d.pdf";